import { useAuth } from '../../context/auth-context'
import { hasPermission } from '../../shared/permissions/permission-helper'
import { UserInfo } from '../../types'
import { PyramidsViewPermissions } from './permissions'

export const useEditForecastPermission = (companyId: string): boolean => {
  const item = PyramidsViewPermissions.editForecast

  const { user } = useAuth()

  const userRoles = user.roles || []

  const hasProvidedPermission = hasPermission(item, userRoles)

  return hasProvidedPermission && isManagerOfSelectedCompany(user, companyId)
}

const isManagerOfSelectedCompany = (user: UserInfo, companyId: string): boolean =>
  user.managedCompanies.some((company) => company.id === companyId)
